import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: false,
      variations: false
    },
    themes: {
      light: {
        primary: "#1E292A",
        secondary: "#E95635",
        accent: "#4D5654",
        error: "#C84229",
        info: "#4D5654",
        success: "#4D5654",
        warning: "#FFC107"
      }
    }
  },
  icons: {
    iconfont: "fa"
  }
});
